export const septemberUppercase = "cra";
export default {septemberUppercase};